let sharedCtx = null;

const getAudioContext = () => {
  if (typeof window === "undefined") return null;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!sharedCtx) sharedCtx = new AudioCtx();
  if (sharedCtx.state === "suspended") {
    sharedCtx.resume().catch(() => {});
  }
  return sharedCtx;
};

const playTone = (frequency, duration = 0.12, { type = "sine", gain = 0.12, when = 0 } = {}) => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const start = ctx.currentTime + when;
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, start);
    gainNode.gain.setValueAtTime(gain, start);
    gainNode.gain.exponentialRampToValueAtTime(0.01, start + duration);
    oscillator.start(start);
    oscillator.stop(start + duration);
  } catch {
    // Ignore audio failures (autoplay policies, unsupported browsers).
  }
};

export const playLanguageClick = () => {
  playTone(660, 0.08, { gain: 0.09, type: "triangle" });
};

export const playLanguageSelect = () => {
  playTone(520, 0.07, { gain: 0.1, type: "triangle" });
  playTone(780, 0.1, { gain: 0.08, type: "sine", when: 0.05 });
};

export const playLanguageCorrect = () => {
  playTone(523.25, 0.12, { gain: 0.12 });
  playTone(659.25, 0.14, { gain: 0.12, when: 0.1 });
  playTone(783.99, 0.18, { gain: 0.12, when: 0.2 });
};

export const playLanguageWrong = () => {
  playTone(220, 0.18, { gain: 0.14, type: "square" });
  playTone(180, 0.22, { gain: 0.1, type: "square", when: 0.12 });
};
